export const OUTGOING_HEADER_NAMES = {
  APP_VERSION: 'x-app-version',
  APP_RECIPE_ID: 'x-app-recipeid',
} as const;

export const INCOMING_HEADER_NAMES = {
  SUPPORTED_APP_VERSION: 'x-supported-app-version',
} as const;
